import React, { Component } from "react";
import { Modal, ControlLabel, FormControl, Button } from "react-bootstrap";
import Select from "react-select";
import { Row, Col } from "react-flexbox-grid";
import { observer, inject } from "mobx-react";

@inject("userStore", "changeSingleFieldValueModalStore")
@observer
export default class ChangeSingleFieldValueModal extends Component {
  componentDidUpdate(prevProps){
    const {
      getModalData
    } = this.props.changeSingleFieldValueModalStore;

    if(!getModalData.options){
      const { changeSingleFieldValueModalStore } = this.props;
      changeSingleFieldValueModalStore.prepareModalWithRestrictedValue();
    }
  }

  render() {
    const { Header, Title, Body, Footer } = Modal;

    const {
      getModalData,
      isVisible,
      toggleVisibility,
      saveNewFieldValue,
      changeFieldValue,
    } = this.props.changeSingleFieldValueModalStore;

    const optionsForNewValue = getModalData.options;

    return (
      <div>
        <Modal
          show={isVisible}
          onHide={toggleVisibility}
        >
          <Header closeButton>
            <Title>{getModalData.title}</Title>
          </Header>
          <Body>
            <ControlLabel>Current {getModalData.fieldLabel}:</ControlLabel>
            <FormControl
                readOnly={true}
                value={getModalData.currentFieldValue}
            />
            <br />
            <ControlLabel>New {getModalData.fieldLabel}:</ControlLabel>
            {!!optionsForNewValue && Object.keys(optionsForNewValue).length > 0 ? (
              <Select
                closeMenuOnSelect={true}
                onChange={selectionOption => changeFieldValue(selectionOption.value)}
                options={optionsForNewValue}
                value={optionsForNewValue.filter(option => getModalData.newFieldValue === option.value)}
              />
            ) : (
              <FormControl
                onChange={e => {
                  changeFieldValue(e.target.value);
                }}
              />
            )}
            <br />
          </Body>
          <Footer>
            <Row>
              <Col md={12} style={{ textAlign: "right" }}>
                <Button onClick={() => toggleVisibility()}>
                  Cancel
                </Button>
                <Button
                  bsStyle="primary"
                  onClick={() => {
                    saveNewFieldValue();
                    toggleVisibility();
                  }}
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Footer>
        </Modal>
      </div>
    );
  }
}
